<template>
  <BaseStyle :model="model" class="content-base">
    <div v-if="opened">
      <div class="cursor-pointer" @click="opened = false">
        <div
          v-for="(content, contentIndex) in model.openedHeaders"
          :key="contentIndex"
        >
          <Content :content="content" />
        </div>
      </div>
      <div>
        <div
          v-for="(content, contentIndex) in model.contents"
          :key="contentIndex"
        >
          <Content :content="content" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="cursor-pointer"
      @click="opened = true"
    >
      <div
        v-for="(content, contentIndex) in model.closedHeaders"
        :key="contentIndex"
      >
        <Content :content="content" />
      </div>
    </div>
  </BaseStyle>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, PropType, ref } from 'vue';

import { ContentAccordinationModel } from '@/models/content_accordination_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentAccordination',
  components: {
    BaseStyle,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentAccordinationModel>,
      required: true,
    },
  },
  setup() {
    const opened = ref(false);
    return {
      opened,
    };
  },
});
</script>
